import { ECSConfigStore } from "sh-ecsconfig-store";
import { mutatorAction } from "satcheljs";

/**
 * Set the ECS config in store
 */
export default mutatorAction("SET_ECS_CONFIG_IN_STORE", (config: any) => {
    ECSConfigStore().config = config;
});